import { ArrowRightIcon, CheckIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const stepKeys = ['choose', 'fill', 'download'] as const;

export function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-surface">
      <div className="absolute inset-x-0 top-0 h-64 bg-[linear-gradient(180deg,#e8f3ff,rgba(255,255,255,0))]" aria-hidden="true" />
      <div className="absolute left-1/2 top-12 h-80 w-[42rem] -translate-x-1/2 rounded-full bg-glow blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto grid min-h-[calc(100svh-73px)] max-w-7xl items-center gap-12 px-5 py-16 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:px-8">
        <div>
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground">
            <ShieldCheckIcon className="size-3.5" aria-hidden="true" />
            {t('hero.badge')}
          </div>
          <h1 className="max-w-4xl text-5xl font-heading font-semibold leading-[1.02] tracking-normal text-foreground sm:text-6xl lg:text-7xl">
            {t('hero.title')}
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-muted-foreground">
            {t('hero.subtitle')}
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a href="/app/" className="inline-flex items-center justify-center gap-2 rounded bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground ring-1 ring-primary-hover transition hover:bg-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-60">
              {t('hero.openApp')}
              <ArrowRightIcon className="size-4" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div className="relative">
          <div className="rounded-lg bg-panel-dark p-6 text-panel-dark-foreground">
            <p className="text-sm font-semibold uppercase tracking-wide text-[color-mix(in_oklch,var(--color-panel-dark-foreground)_85%,var(--color-primary))]">
              {t('hero.stepsTitle')}
            </p>
            <ul className="mt-5 flex flex-col gap-3">
              {stepKeys.map((key) => (
                <li key={key} className="flex items-center gap-3 text-sm">
                  <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
                    <CheckIcon className="size-3" aria-hidden="true" />
                  </span>
                  <span className="text-panel-dark-foreground">{t(`hero.steps.${key}`)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
